import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { KycModalComponent } from "@modules/kyc/components/kyc-modal/kyc-modal.component";
import { KYC_HOME_REVIEW_BUTTON_CLICK_EVENT } from "@helpers/constants";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "kyc-banner",
	templateUrl: "./kyc-banner.component.html",
	styleUrls: ["./kyc-banner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class KycBannerComponent {
	public constructor(
		private modalService: ModalService,
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	public onReviewClick(): void {
		this.modalService.create(KycModalComponent).present();

		this.segmentService.track({ name: KYC_HOME_REVIEW_BUTTON_CLICK_EVENT });
		this.rudderstackService.track({ name: KYC_HOME_REVIEW_BUTTON_CLICK_EVENT });
	}
}
